'use strict';

var _ = require('lodash');

function SettingsRoutes ($stateProvider) {
  $stateProvider
  .state('settings', {
    url: '/settings',
    controller: 'SettingsController',
    controllerAs: 'vm',
    templateUrl: 'settings/settings.tpl.html',
    resolve: {
      authenticate: [
        '$location', '$state', '$q', '$timeout', 'AuthService',
        function ($location, $state, $q, $timeout, AuthService) {
          var deferred = $q.defer();
          var authenticated = AuthService.isAuthenticated();
          var params = {
            location: $location.path() === '/' ? '' : $location.path()
          };

          $timeout(function () {
            if (authenticated) {
              deferred.resolve();
            } else {
              $state.go('login', params);
              deferred.reject();
            }
          });
          return deferred.promise;
        }
      ],
      invitations: [
        'sbFlux', 'authenticate',
        function (Flux, authenticate) {
          // unfortunately we can't depend on the OrganizationStore resolve here because resolves on one state run in parallel
          var OrganizationStore = Flux.Store.get('OrganizationStore');
          return OrganizationStore.loadInvitations();
        }
      ],
      OrganizationStore: [
        'sbFlux', 'authenticate',
        function (Flux) {
          return Flux.Store.get('OrganizationStore');
        }
      ],
      PlanStore: [
        'sbFlux', 'authenticate',
        function (Flux) {
          return Flux.Store.get('PlanStore');
        }
      ],
      SettingsStore: [
        'sbFlux', 'authenticate',
        function (Flux) {
          return Flux.Store.get('SettingsStore');
        }
      ],
      ManagerStore: [
        'sbFlux', 'authenticate',
        function (Flux) {
          return Flux.Store.get('ManagerStore');
        }
      ],
      organization: [
        'OrganizationStore', 'PlanStore', 'authenticate', 'IngestorService',
        function (OrganizationStore, PlanStore, authenticate, IngestorService) {
          return OrganizationStore.loadOrganization()
          .then(function (organization) {
            return PlanStore.preloadOrgPlanData()
            .then((plan) => {
              IngestorService.attachIngestor()
              return plan
            })
            .then(function () {
              return organization;
            });
          });
        }
      ]
    }
  })
  .state('settings.myProfile', {
    url: '/profile',
    controller: 'MyProfileController',
    controllerAs: 'vm',
    templateUrl: 'settings/myProfile/myProfile.tpl.html'
  })
  .state('settings.changePassword', {
    url: '/change-password',
    controller: 'ChangePasswordController',
    controllerAs: 'vm',
    templateUrl: 'settings/changePassword/changePassword.tpl.html'
  })
  .state('settings.account', {
    url: '/account',
    controller: 'SettingsAccountController',
    controllerAs: 'vm',
    templateUrl: 'settings/account/account.tpl.html'
  })
  .state('settings.access', {
    url: '/access',
    controller: 'SettingsAccessController',
    controllerAs: 'vm',
    templateUrl: 'settings/access/access.tpl.html'
  })
  .state('settings.organization', {
    // for more info on nested and abstract states: https://github.com/angular-ui/ui-router/wiki/Nested-States-and-Nested-Views
    abstract: true, // abstract states can't be transitioned to. they are useful for resolving dependencies and prepending urls for child states
    url: '/organization',
    template: '<ui-view/>', // abstract states require a ui-view for child states to hook into
    resolve: { // we now only have to load the organization once for the entire org settings module since they're not needed in my settings
      // We can create a resolve hierarchy since this is a nested state inside settings which already resolved the OrganizationStore
      // See http://stackoverflow.com/questions/21983452/promise-dependency-resolution-order-in-angular-ui-router
      isAdmin: [
        '$state', '$timeout', '$q', 'IdentityService',
        function ($state, $timeout, $q, IdentityService) {
          var deferred = $q.defer();
          $timeout(function () {
            if(!IdentityService.isOrganizationAdmin()) {
              $state.go('settings.myProfile');
              deferred.reject();
            } else {
              deferred.resolve();
            }
          });
          return deferred.promise;

        }
      ]
    }
  })
  .state('settings.organization.users', {
    url: '/users?command',
    params: {
      command: null
    },
    controller: 'SettingsOrgUsersController',
    controllerAs: 'vm',
    templateUrl: 'settings/orgUsers/overview.tpl.html'
  })
  .state('settings.organization.users.detail', {
    url: '/:user',
    controller: 'SettingsOrgUserDetailsController',
    controllerAs: 'vm',
    templateUrl: 'settings/orgUsers/detail.tpl.html',
    // resolve: {
    //   sites: [
    //     '$stateParams', 'OrganizationStore', 'organization',
    //     function ($stateParams, OrganizationStore, organization) {
    //       return OrganizationStore.loadUserSites($stateParams.user, organization);
    //     }
    //   ]
    // }
  })
  .state('settings.organization.sites', {
    url: '/sites',
    controller: 'SettingsOrgSitesController',
    controllerAs: 'vm',
    templateUrl: 'settings/orgSites/overview.tpl.html'
  })
  .state('settings.organization.sites.detail', {
    url: '/:site',
    controller: 'SettingsOrgSiteDetailsController',
    controllerAs: 'vm',
    templateUrl: 'settings/orgSites/detail.tpl.html',
    resolve: {
      project: [
        '$http', '$stateParams', 'organization', 'sbAuth', 'IdentityService', 'SettingsActions',
        function ($http, $stateParams, organization, sbAuth, IdentityService, SettingsActions) {
          let project = _.find(organization.projects, function (project) {
            return project.id === parseInt($stateParams.site, 10);
          });
          let siteId = _.get(project, ['sites', 0, 'id']);
          return sbAuth.getToken()
          .then(function(token) {
            return $http({
              method: 'GET',
              headers: {
                'Authorization': 'Bearer ' + token
              },
              url: IdentityService.getApiUri() + 'sites/' + siteId + '/settings'
            })
            .then(function(res) {
              project.settings = res.data.data;
              return project;
            })
            .catch(function(err) {
              // the user doesn't have permission to read this site, let's redirect to the organization settings
              SettingsActions.CloseDetailView.dispatch();
              return err.data;
            });
          });
        }
      ]
    }
  })
  // .state('settings.organization.billing', {
  //   url: '/billing',
  //   controller: 'SettingsOrgBillingController',
  //   controllerAs: 'vm',
  //   templateUrl: 'settings/orgBilling/billing.tpl.html'
  // });
}

SettingsRoutes.$inject = ['$stateProvider'];
module.exports = SettingsRoutes;



// WEBPACK FOOTER //
// ./src/app/settings/SettingsRoutes.js